<template>
  <div>
    <div class="table" v-if="groupby === 'employee'">
      <el-table
        v-if="!reports.length"
        style="margin-bottom: 20px"
        :data="[]"
        width="100%"
        v-loading="loading"
        empty-text="No Lateness Reports available."
      >
      </el-table>
      <el-table
        v-else
        v-for="report of reports"
        :key="report.pin"
        style="margin-bottom: 20px"
        :data="report.days"
        width="100%"
        v-loading="loading"
        empty-text="No Lateness Reports available."
        class="colored-head"
      >
        <el-table-column :label="getHeader(report)">
          <el-table-column
            sortable
            prop="checkdate"
            label="DATE"
          ></el-table-column>
          <el-table-column
            sortable
            prop="shift_name"
            label="SHIFT"
          ></el-table-column>
          <el-table-column
            sortable
            prop="clockin_readable"
            label="CLOCK IN"
          ></el-table-column>
          <el-table-column
            sortable
            prop="expected_clockin_readable"
            label="EXPECTED CLOCKIN"
          ></el-table-column>
          <el-table-column
            sortable
            prop="lost_time"
            label="LOST TIME"
          ></el-table-column>
        </el-table-column>
      </el-table>
    </div>

    <div class="table" v-else>
      <el-table
        v-if="!reports.length"
        style="margin-bottom: 20px"
        :data="[]"
        width="100%"
        v-loading="loading"
        empty-text="No Lateness Reports available."
      >
      </el-table>
      <el-table
        v-else
        v-for="report of reports"
        :key="report.pin"
        style="margin-bottom: 20px"
        :data="report.employees"
        width="100%"
        v-loading="loading"
        empty-text="No Lateness Reports available."
        class="colored-head"
      >
        <el-table-column :label="getDateHeader(report.date)">
          <el-table-column prop="employee_details" label="Name" width="200">
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="employee_details" label="Pin" width="200">
            <template slot-scope="scope">
              {{ scope.row.employee_details.pin }}
            </template>
          </el-table-column>
          <el-table-column
            prop="custom_employee_id"
            width="200"
            label="Custom Id"
            v-if="
              'custom_employee_id' in reports[0].employees[0].employee_details
            "
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.custom_employee_id || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            width="200"
            label="Employee Grade"
            v-if="'employee_grade' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.employee_grade || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            width="200"
            label="Employee Type"
            v-if="'employee_type' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.employee_type || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            width="200"
            label="Employee Category"
            v-if="
              'employee_category' in reports[0].employees[0].employee_details
            "
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.employee_category || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            width="200"
            label="Mobile Number"
            v-if="'mobile_number' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.mobile_number || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            width="200"
            label="Email"
            v-if="'email' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.email || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            width="200"
            label="Department"
            v-if="'department' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.department || "NA" }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="employee_details"
            width="200"
            label="Branch"
            v-if="'branch' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.branch || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="shift_name"
            width="200"
            label="SHIFT"
          ></el-table-column>
          <el-table-column
            sortable
            prop="clockin_readable"
            width="200"
            label="CLOCK IN"
          ></el-table-column>
          <el-table-column
            sortable
            prop="expected_clockin_readable"
            width="200"
            label="EXPECTED CLOCKIN"
          ></el-table-column>
          <el-table-column
            sortable
            prop="lost_time"
            width="200"
            label="LOST TIME"
          ></el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reports", "groupby", "loading"],

  methods: {
    getHeader(report) {
      return `Employee Name: ${report.employee_details.name} - Pin: ${
        report.employee_details.pin
      }`;
    },

    getDateHeader(date) {
      return `Lateness Report for: ${date}`;
    },
  },
};
</script>
